import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  patients: [],
  treatments: [],
  currentPatient: null,
  loading: false,
  error: null,
};

const nikshaySlice = createSlice({
  name: 'nikshay',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setPatients: (state, action) => {
      state.patients = action.payload;
    },
    setTreatments: (state, action) => {
      state.treatments = action.payload;
    },
    setCurrentPatient: (state, action) => {
      state.currentPatient = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, setPatients, setTreatments, setCurrentPatient, setError, clearError } = nikshaySlice.actions;
export default nikshaySlice.reducer;